import React from "react"
import PropTypes from "prop-types"
import { toggle, setAll } from "../../redux/selection"
import { showSelectedOnly } from "../../redux/settings"
import { setParam, fetch } from "../../redux/query"
import store from "../../redux"
import { connect } from "react-redux"
// import "./Dashboard.less"
import ReactJson from "react-json-view"
import { withRouter } from "../../lib/withRouter"
import Header2 from "../Header2"
import { getQuickSightUrl, getViewPatientData } from "../../lib"
import moment from "moment"
import PreScreeningTab from "./PreScreeningTab"

export class PreScreening extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        console.log("Pre Screening", this.props.settings)
        const query = new URLSearchParams(this.props.location.search);

        // CHECK REDIRECT TABS
        const _tab = query.get("_tab");
        if (["demographics", "conditions", "tags"].includes(_tab)) {
            query.delete("_resource");
            const clean = query.toString() ? `?${query.toString()}` : "";
            this.props.router.navigate(`/patient-list${clean}`);
            return;
        }

    }
    render() {
        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />
                </div>

                <div className="">
                    <PreScreeningTab
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />
                </div>
            </div>
        )
    }

}

export default connect(state => state)(withRouter(PreScreening));